import React, { Component } from 'react'
import utils from '../utils'
const { FE } = utils

export default class MiniHeader extends Component {
  render(){
    return(
      <div className={FE.APP.isApp()?"miniheader fn-hide":"miniheader"}>
        <div className="miniheader-logo">
          <a className="miniheader-logo-all" href={FE.Utils.getHref("//m.mall.autohome.com.cn/")}>
            <img src="//x.autoimg.cn/j/mall/2016/m/images/logo-2b77c.png" alt="" />
          </a>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/MiniHeader.js